import { Fade } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";

// Transition component for DepositCryptoModal
const ModalTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
): JSX.Element {
  return <Fade ref={ref} {...props} />;
});

export default ModalTransition;
